/*******************************************************
 * ESTADO GLOBAL Y SELECTORES DEL DOM
 * Este archivo solo contiene datos reactivos y accesos al DOM.
 * Toda la configuración vive en config.js.
 *******************************************************/

/**
 * Estado reactivo de la aplicación.
 */
export const state = {
    categories: [],
    products: [],
    activeMajorSectionId: null,
    loading: true,
    error: null,

    // Pre-computed indexes for fast lookup in renderProductsUI (populated by MenuService._processData)
    productsByCategory: new Map(),
    productsBySection: new Map(),

    // categoryId → aclaración a mostrar debajo del header de esa categoría
    // (derivada de los grupos de modificadores de Fudo, ver MenuService).
    categoryNotes: new Map(),

    // Router State
    currentPath: '/',

    // Reserva State
    reserva: {
        step: 1,
        nombre: '',
        apellido: '',
        telCodigo: '',
        telNumero: '',
        telefono: '',
        personas: 2,
        fecha: '',
        momento: '',
        hora: '',
        area: ''
    }
};

/**
 * Selectores del DOM centralizados.
 * Se obtienen bajo demanda para asegurar que el DOM esté listo.
 */
export const DOM = {
    get publicShell() { return document.getElementById('publicShell'); },
    get sidebar() { return document.getElementById('sidebar'); },
    get sidebarOverlay() { return document.getElementById('sidebarOverlay'); },
    get sidebarContent() { return document.getElementById('sidebarContent'); },
    get sidebarButtons() { return document.getElementById('sidebarButtons'); },
    get sectionSubtitle() { return document.getElementById('sectionSubtitle'); },

    get products() { return document.getElementById('productsContainer'); },
    get macroTabs() { return document.getElementById('macroTabs'); },
    get macroTabsContainer() { return document.getElementById('macroTabsContainer'); },
    get connBanner() { return document.getElementById('connStatus'); },
    get connMessage() { return document.getElementById('connMessage'); },
    
    get mainNavigation() { return document.getElementById('mainNavigation'); }, 
    get menuSelectionContainer() { return document.getElementById('menuSelectionContainer'); }, 
    get viewWelcome() { return document.getElementById('view-welcome'); },
    get viewMenu() { return document.getElementById('view-menu'); },
    get viewMenuSelection() { return document.getElementById('view-menu-selection'); },
    get viewEventos() { return document.getElementById('view-eventos'); },
    get viewReservas() { return document.getElementById('view-reservas'); },
    get viewAdmin() { return document.getElementById('view-admin'); },
    get whatsappFloat() { return document.getElementById('whatsapp-float'); },

    get eventosForm() { return document.getElementById('eventosForm'); },
    get reservaWizardContainer() { return document.getElementById('reservaWizardContainer'); },
    get adminContainer() { return document.getElementById('adminContainer'); },
    get mainFooter() { return document.querySelector('footer'); }
};
